module.exports = __webpack_public_path__ + "img/comingSoon.b20834c8.svg";